import { Stack } from 'expo-router';
import { ScrollView } from 'react-native';
import { StyleSheet } from 'react-native-unistyles';
import Box from '@/components/UI/Box';
import EventShareStandingsWidget from './components/EventShareStandingsWidget';

export default function EventShareStandings() {
  return (
    <ScrollView contentContainerStyle={style.scrollView}>
      <Stack.Screen options={{ title: 'Standings Share' }} />
      <Box space="lg" p="lg" alignItems="center">
        <EventShareStandingsWidget />
      </Box>
    </ScrollView>
  );
}

const style = StyleSheet.create((_, rt) => ({
  scrollView: {
    paddingBottom: rt.insets.bottom,
  },
}));
